import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("g", null, [
              _createElementVNode("path", {
                fill: "#FFF",
                d: "M12.306 4.32c.191-.199.508-.205.707-.014.181.174.203.451.062.65l-.048.057-6.405 6.667c-.184.191-.482.203-.68.038l-.051-.049-2.928-3.232c-.186-.205-.17-.521.035-.707.186-.168.464-.17.652-.016l.054.051 2.568 2.836 6.034-6.28z",
                transform: "translate(-968 -212) translate(960 176) translate(0 32) translate(8 4)"
              })
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }